export const RESET_STAFF_MEMBERS = 'RESET_STAFF_MEMBERS'
export const SET_STAFF_MEMBERS = 'SET_STAFF_MEMBERS'
export const SET_STAFF_MEMBERS_SEARCH = 'SET_STAFF_MEMBERS_SEARCH'
export const SET_GROUPS = 'SET_GROUPS'
export const RESET_GROUPS = 'RESET_GROUPS'
